import React, { createContext, useContext, useState, useCallback } from "react";
import translations from "./translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("amora_lang") || "sq");

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "sq" ? "en" : "sq";
      localStorage.setItem("amora_lang", next);
      return next;
    });
  }, []);

  // t("hero.title") → looks up the nested key in the active language.
  const t = useCallback(
    (key) => {
      let val = translations[lang];
      for (const part of key.split(".")) val = val?.[part];
      return val ?? key;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
